import React from 'react';
import { Link } from 'react-router-dom';

// Import translation
import i18n from 'i18next';

export const createColumns = (handleSelectItem, isReadOnly) => [
	{
		Header: i18n.t('limits:table_columns.group_name'),
		accessor: 'group_name',
		Cell: ({
			row: {
				_original: { id, group_name }
			}
		}) => <Link to={`/panel/limits/edit/${id}/metadata`}>{group_name}</Link>
	},
	{
		Header: i18n.t('limits:table_columns.limit'),
		accessor: 'limit'
	},
	{
		Header: i18n.t('limits:table_columns.created_at'),
		accessor: 'created_at'
	},
	{
		Header: i18n.t('limits:table_columns.updated_at'),
		accessor: 'updated_at'
	},
	{
		Header: i18n.t('common:table_columns.delete'),
		accessor: 'delete',
		width: 60,
		className: 'text-center',
		sortable: false,
		Cell: ({
			row: {
				_original: { id }
			}
		}) =>
			!isReadOnly && (
				<button
					onClick={() => handleSelectItem(id)}
					className="btn btn-xs btn-primary"
				>
					<i className="fa fa-trash" />
				</button>
			)
	}
];
